import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Links from "./Links";
import styles from "./MainContent.css";
import MyAccountLinks from "../MyAccountLinks";
import SocialLinks from "./SocialLinks";
import PaymentOptions from "./PaymentOptions";
import Greeter from "../Greeter";
import AppDownload from "../AppDownload";
import NewsletterSignupForm from "./NewsletterSignupForm";
import { SMALL_VIEWPORT } from "../../state/modules/layout";
import withViewport from "../Viewport/withViewport";
import classnames from "classnames";
import { getLoyaltyStatus } from "@template/state/modules/loyalty";
import { useSelector } from "react-redux";
import { isLoggedIn } from "../../state/modules/user";

const MainContent = ({ items, isAccordion, isBrazeInitialised = false }) => {
  const { optedIn, isAvailable, tierName, tierNumber } =
    useSelector(getLoyaltyStatus);
  const authenticated = useSelector(state => isLoggedIn(state));
  const [showMyAccountNotification, setShowMyAccountNotification] =
    useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (authenticated && isAvailable && !optedIn) {
      const clearNotificationWaiting =
        localStorage && localStorage.getItem("clearNotificationWaiting");
      setShowMyAccountNotification(!clearNotificationWaiting);
    }
  }, [optedIn, authenticated, isAvailable]);

  useEffect(() => {
    if (optedIn) {
      localStorage.removeItem("clearNotificationWaiting");
      setShowMyAccountNotification(false);
    }
  }, [optedIn]);

  const appDownloadCtaRef = isAccordion
    ? "sideNavigation footer|appDownload component|our apps"
    : "global footer|appDownload component|our apps";

  return (
    <div
      className={classnames({
        [styles.pageFooter]: !isAccordion,
        [styles.pageFooterLoggedOut]:
          !isAccordion && !authenticated && isBrazeInitialised
      })}
    >
      <div className={styles.iconBar}>
        <SocialLinks />
        <PaymentOptions />
      </div>
      <div className={styles.greeterWrapper}>
        <Greeter
          viewable={[SMALL_VIEWPORT]}
          tierName={tierName}
          tierNumber={tierNumber}
        />
      </div>
      <MyAccountLinks
        viewable={[SMALL_VIEWPORT]}
        queryParams={{ nlid: "nav footer" }}
        showMyAccountNotification={showMyAccountNotification}
      />
      {!isMounted ? null : authenticated || !isBrazeInitialised ? (
        <div
          className={classnames({
            [styles.footerLinksContainer]: true,
            [styles.accordionFooterLinksContainer]: isAccordion
          })}
        >
          <AppDownload
            isSideNavigation={isAccordion}
            isLoggedIn={authenticated}
            isBrazeInitialised={isBrazeInitialised}
            ctaRef={appDownloadCtaRef}
          />
          <Links items={items} isAccordion={isAccordion} />
        </div>
      ) : (
        <div
          className={styles.loggedOutSubsection}
          data-testid="logged-out-footer-subsection"
        >
          <div className={styles.loggedOutSubsectionRow}>
            <div className={styles.innerWrapper}>
              <NewsletterSignupForm />
              <AppDownload
                isSideNavigation={isAccordion}
                isLoggedIn={authenticated}
                isBrazeInitialised={isBrazeInitialised}
                ctaRef={appDownloadCtaRef}
              />
            </div>
          </div>
          <Links items={items} isAccordion={isAccordion} />
        </div>
      )}
    </div>
  );
};

MainContent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  isAccordion: PropTypes.bool.isRequired,
  isBrazeInitialised: PropTypes.bool
};

export default withViewport(MainContent);
